/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TicketTimeLimitOverrideTimeConfigItem
 */
export interface TicketTimeLimitOverrideTimeConfigItem {
    /**
     * 
     * @type {number}
     * @memberof TicketTimeLimitOverrideTimeConfigItem
     */
    hour?: number;
    /**
     * 
     * @type {number}
     * @memberof TicketTimeLimitOverrideTimeConfigItem
     */
    minute?: number;
}

export function TicketTimeLimitOverrideTimeConfigItemFromJSON(json: any): TicketTimeLimitOverrideTimeConfigItem {
    return TicketTimeLimitOverrideTimeConfigItemFromJSONTyped(json, false);
}

export function TicketTimeLimitOverrideTimeConfigItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketTimeLimitOverrideTimeConfigItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hour': !exists(json, 'hour') ? undefined : json['hour'],
        'minute': !exists(json, 'minute') ? undefined : json['minute'],
    };
}

export function TicketTimeLimitOverrideTimeConfigItemToJSON(value?: TicketTimeLimitOverrideTimeConfigItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hour': value.hour,
        'minute': value.minute,
    };
}


